import api from './api';

export async function fetchStates() {
  const response = await api.get('/states');
  if (response?.data?.error || Number(response?.data?.code) >= 400) {
    throw new Error(response?.data?.message || 'Unable to load states.');
  }
  return response?.data?.dataset?.data || {};
}

export async function addStateFavourite(payload) {
  const response = await api.post('/add-state-favourite', payload);
  if (response?.data?.error || Number(response?.data?.code) >= 400) {
    throw new Error(response?.data?.message || 'Unable to update favorite state.');
  }

  return {
    payload: response?.data?.dataset?.data || {},
    meta: response?.data || {},
  };
}

export async function saveResidentialState(stateId) {
  const response = await api.post('/add-user-residential-state', { state_id: Number(stateId) });
  if (response?.data?.error || Number(response?.data?.code) >= 400) {
    throw new Error(response?.data?.message || 'Unable to save residential state.');
  }
  return response?.data?.dataset?.data || {};
}
